// import { useContext } from "react";
// import { LocaleContext } from "../components/ui/LocaleWrapper";
import website from "../../config/website";

export function fileNameByUrl(url) {
  const decoded = decodeURIComponent(url);
  return decoded.substring(decoded.lastIndexOf("/") + 1);
}

// export const _getLocale = () => {
//   const { localeCtx } = useContext(LocaleContext);
//   return localeCtx || "fr";
// };

// export function _localizeField(field) {
//   // console.log("_localizeField");
//   // console.log(field);
//   const locale = _getLocale();
//   // console.log(locale);
//   return field[locale] ? field[locale] : field;
// }

// export const _localizeText = text => {
//   const locale = _getLocale();
//   return locales[locale] && locales[locale][text]
//     ? locales[locale][text]
//     : text;
// };

// export const _localizeSlug = node => {
//   const locale = _getLocale();
//   return locales[locale].default
//     ? `/${node.slug.current}`
//     : `/${locale}/${node.slug.current}`;
// };

// export const _getHomeUrl = () => {
//   const locale = _getLocale();
//   return locales[locale].default ? `/` : `/${locales[locale]["path"]}`;
// };

export const _absoluteLinkResolver = doc => {
  const root = website.url;
  const path = _linkResolver(doc);
  return `${root}${path}`;
};
export const _linkResolver = doc => {
  // console.log(doc);
  if (doc._type === "pageModulaire") return `${doc.slug.current}`;
  if (doc._type === "product") return `/product/${doc.slug.current}`;

  return "/";
};

export const _allAddClass = (wrapper, selector, className) => {
  wrapper.querySelectorAll(selector).forEach(el => {
    console.log(el.classList.add(className));
    el.classList.add(className);
  });
};

export const _allRemoveClass = (wrapper, selector, className) => {
  wrapper
    .querySelectorAll(selector)
    .forEach(el => el.classList.remove(className));
};
